module.exports = __webpack_public_path__ + "img/mitsu-ScheduleService.41173740.png";